// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Проблеми законодавства» (Legislation Issues, ключ `lis`, група `legislation`). */
export const legislationIssuesManifest: IModuleManifest = {
  key: 'lis',
  group: 'legislation',
  slug: 'legislation-issues',
  prefix: 'LIS',
  name: { en: 'Legislation Issues', uk: 'Проблеми законодавства' },
  entities: [
    { key: 'lis', slug: 'lis', name: { en: 'Legislation Issues', uk: 'Проблеми законодавства' }, main: true },
    { key: 'issue_affected_article', slug: 'issue-affected-article', name: { en: 'Issue Affected Articles', uk: 'Зачеплені статті' }, main: false },
    { key: 'issue_evidence', slug: 'issue-evidence', name: { en: 'Issue Evidences', uk: 'Докази' }, main: false },
    { key: 'lis_issue_resolution', slug: 'lis-issue-resolution', name: { en: 'Issue Resolutions', uk: 'Вирішення' }, main: false },
  ],
  loadState: () => import('./state/legislationIssuesSlice').then((m) => m.legislationIssuesSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
